export const handleErrorModifyPassword = (
  error: any,
  errorMessage: string,
): void => {
  console.error(errorMessage, error);
  // Ajoutez ici une gestion des erreurs plus sophistiquée si nécessaire
};
